import Icon from '../../components/Icon.vue';
Icon.register({
  'regular/frown': {
    width: 496,
    height: 512,
    paths: [{
      d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM328 176c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM248 304c40.2 0 78 17.7 103.8 48.6 8.4 10.2 7.1 25.3-3.1 33.8-10.7 8.8-25.7 6.6-33.8-3.1-16.6-20-41-31.4-66.9-31.4s-50.3 11.5-66.9 31.4c-8.5 10.2-23.6 11.5-33.8 3.1-10.2-8.5-11.6-23.6-3.1-33.8 25.8-30.9 63.6-48.6 103.8-48.6z'
    }]
  }
});